(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemEdit", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/edit/learningItemEditView.html",
            controller: ["learningItemResource", "$uibModal", "$state", "$stateParams", "$localStorage", "_", LearningItemEditCtrl],
            controllerAs: "vm"
        };
        function LearningItemEditCtrl(learningItemResource, $uibModal, $state, $stateParams, $localStorage, _) {
            var vm = this;
            vm.openModal = openModal;
            vm.previewLearningItem = previewLearningItem;
            vm.showEditButton = true;
            vm.state = $state;
            vm.showManageTranslations = $localStorage.tenantSettings.enabledLocalizations.length > 1;
            $localStorage.currentLocalizationId = parseInt($localStorage.currentLocalizationId); //still not sure how/when this switches to a string
            vm.learningItemResourceObject = learningItemResource.get({ code: $stateParams.code }, function (result) {
                vm.learningItem = result;
                vm.showManageSeminars = result.typeId === 7;
                checkToShowEditButton();
                vm.loaded = true;
            });
            function checkToShowEditButton() {
                if (vm.learningItem.localizationId !== $localStorage.tenantSettings.defaultLocalization.id) {
                    vm.showEditButton = false;
                }
            }
            function openModal() {
                var $modalInstance = $uibModal.open({
                    templateUrl: "/app/learningItems/edit/learningItemEditCommonInfoModalView.html",
                    controller: "LearningItemEditCommonInfoModalCtrl as vm",
                    size: "lg",
                    resolve: {
                        learningItem: function () {
                            return angular.copy(vm.learningItem);
                        }
                    }
                });
                $modalInstance.result.then(function (result) {
                    vm.learningItem = result;
                }).catch(angular.noop);
            }
            function previewLearningItem() {
                $uibModal.open({
                    templateUrl: "app/learningItems/preview/learningItemPreviewModal.html",
                    controller: "LearningItemPreviewModalCtrl as vm",
                    resolve: {
                        previewData: function () {
                            var data = {
                                typeName: vm.learningItem.typeName,
                                typeIconCssClass: vm.learningItem.typeIconCssClass,
                                typeId: vm.learningItem.typeId,
                                itemName: vm.learningItem.name,
                                itemPriorityItem: vm.learningItem.priorityItem,
                                itemExpires: vm.learningItem.expires,
                                itemExpireDays: vm.learningItem.expireDays,
                                itemExpireMonths: vm.learningItem.expireMonths,
                                itemExpireYears: vm.learningItem.expireYears,
                                itemTimeDays: vm.learningItem.timeDays,
                                itemTimeHours: vm.learningItem.timeHours,
                                itemTimeMinutes: vm.learningItem.timeMinutes,
                                itemDescription: vm.learningItem.description
                            };
                            switch (vm.learningItem.typeId) {
                                case 1:
                                    data.specificInfo = {
                                        files: _.where(vm.learningItem.learningItemFiles, { localizationId: vm.learningItem.localizationId })
                                    };
                                    break;
                                case 2:
                                    break;
                                case 3:
                                    data.specificInfo = _.where(vm.learningItem.learningItemOnlineExams, { localizationId: vm.learningItem.localizationId })[0];
                                    break;
                                case 4:
                                    break;
                                case 5:
                                    data.specificInfo = {
                                        files: _.where(vm.learningItem.learningItemFiles, { localizationId: vm.learningItem.localizationId })
                                    };
                                    break;
                                case 6:
                                    var learningItemUrlLocalization = _.where(vm.learningItem.learningItemUrlLocalizations, { localizationId: $localStorage.currentLocalizationId })[0];
                                    var displayOptionMode = learningItemUrlLocalization.embed ? "embedcode" : "url";
                                    data.specificInfo = {
                                        displayOptionMode: displayOptionMode,
                                        embed: learningItemUrlLocalization.embed,
                                        modalSize: learningItemUrlLocalization.modalSize,
                                        url: learningItemUrlLocalization.url
                                    };
                                    break;
                                case 7:
                                    break;
                                case 8:
                                    data.specificInfo = {
                                        archives: _.where(vm.learningItem.learningItemWebinarArchives, { learningItemId: vm.learningItem.learningItemId })
                                    };
                                    break;
                                case 10:
                                    data.specificInfo = {
                                        files: _.where(vm.learningItem.learningItemFiles, { localizationId: vm.learningItem.localizationId })
                                    };
                                    break;
                                case 11:
                                    data.specificInfo = {
                                        isEdit: true,
                                        assignment: _.where(vm.learningItem.learningItemAssignmentLocalizations, { localizationId: $localStorage.currentLocalizationId })[0]
                                    };
                                    break;
                                case 12:
                                    data.specificInfo = _.where(vm.learningItem.learningItemOnlineExams, { localizationId: vm.learningItem.localizationId })[0];
                                    break;
                                case 13:
                                    data.specificInfo = {
                                        isEdit: true,
                                        assignment: _.where(vm.learningItem.learningItemWorkHistoryLocalizations, { localizationId: $localStorage.currentLocalizationId })[0]
                                    };
                                    break;
                                default:
                            }
                            return data;
                        }
                    }
                }).result.catch(angular.noop);
            }
        }
    });
})();
